import { maghMelaPage, maghMelaPageChildren } from './page-magh-mela';
import { packagesPage, packagesPageChildren } from './page-packages';
import { PageRoutes } from './page-routes';
import { Page } from './pages-types';

const allPages = [
  maghMelaPage,
  maghMelaPageChildren,
  packagesPage,
  packagesPageChildren,
].flat();

export class PageStore {
  pages = new Map<PageRoutes, Page>(allPages.map((p) => [p.path, p]));

  getPageOrThrow = (path: PageRoutes) => {
    const page = this.pages.get(path);
    if (!page) {
      throw Error('page not found');
    }

    return page;
  };
}

export const pageStore = new PageStore();
